import { differenceInCalendarDays, format } from 'date-fns'
import { t } from '@/i18n'

/**
 * Formats a note timestamp for display.
 * - Under 7 days: relative ("Just now", "{n} days ago") routed through i18n.
 * - 7 days or older: absolute like "Sep 12, 2026".
 */
export function formatNoteTimestamp(value: string | Date, now: Date = new Date()): string {
    const date = value instanceof Date ? value : new Date(value)
    const days = differenceInCalendarDays(now, date)

    if (days >= 7) {
        return format(date, 'MMM d, yyyy')
    }

    if (days <= 0) {
        return t('supportNotes.time.justNow')
    }

    if (days === 1) {
        return t('supportNotes.time.yesterday')
    }

    return t('supportNotes.time.daysAgo', { n: days })
}
